import { BarChart, DashboardIcon, Payment, UserFriendIcon, UsersIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/dashboard')({
  loader: ({ context }) => {
    context.groupLabel = 'dashboard.sidebar.title';
    context.childRoutes = [
      {
        id: 'dashboard.sidebar.menu.overview',
        label: 'Overview',
        path: '/dashboard/overview',
        icon: DashboardIcon,
      },
      {
        id: 'dashboard.sidebar.menu.reservationLedger',
        label: 'Reservation Ledger',
        path: '/dashboard/reservation-ledger',
        icon: BarChart,
      },
      {
        id: 'dashboard.sidebar.menu.paymentSales',
        label: 'Payment/Sales',
        path: '/dashboard/sales-performance',
        icon: Payment,
      },
      {
        id: 'dashboard.sidebar.menu.conversionActivity',
        label: 'Conversion Activity',
        path: '/dashboard/conversion-analytics',
        icon: UserFriendIcon,
      },
      {
        id: 'dashboard.sidebar.menu.referralReports',
        label: 'Referral Reports',
        path: '/dashboard/referral-reports',
        icon: UsersIcon,
      },
    ];
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
